module.exports = __webpack_public_path__ + "img/eurogastro-pic.e0afb981.png";